import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Tab, Tabs, Popover, Overlay } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import Constants from '../../config/constants';
import Layout from '../../components/layout/Layout';
import Select from 'react-select';
import Card from '../../components/card/Card';
import DataTable from '../../components/datatable/DataTable';
import SearchBar from '../../components/datatable/SearchBar';
import PaginateSelect from '../../components/field_group/PaginateSelect';

import { COLUMN_STYLE, getColumnStyle } from '../../components/datatable/util';

import 'react-dates/initialize';
import moment from 'moment';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import { defaultRejectHandler, getStatusStyle } from '../../utils/utility';

import { listProjectInspection } from '../../redux/project_inspection/project_inspection_actions';
import { listAttachment } from '../../redux/project_inspection/submission_attachment_actions';
import { searchProfile } from '../../redux/profile/profile_actions';

class ProjectInspectionPage extends React.Component {
  constructor(props) {
    super(props);

    const { t } = this.props;
    const textColumn = getColumnStyle(COLUMN_STYLE.text);

    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      filtered: null,
    };

    this.columns = [
      {
        id: 'project-name',
        Header: () => <b>{t('project')}</b>,
        accessor: item => ({ id: item.id, project_name: item.project_name }),
        Cell: row => <Link to={`/project_inspections/${row.value.id}`}>{row.value.project_name}</Link>,
        ...textColumn,
      },
      {
        Header: () => <b>{t('sender')}</b>,
        accessor: 'developer',
        ...textColumn,
      },
      {
        id: 'submitted_date',
        Header: () => <b>{t('submitted date')}</b>,
        accessor: 'submission_date',
        Cell: row => <span>{new moment(row.value).format('D/MM/YYYY')}</span>,
        ...textColumn,
        width: 120,
      },
      {
        id: 'project_status',
        Header: () => <b>{t('status')}</b>,
        accessor: 'status',
        Cell: row => <span className={getStatusStyle(row.value)}>{t(String(row.value).toLowerCase())}</span>,
        ...textColumn,
        width: 120,
      },
    ];

    this.today = moment();

    this.state = {
      date: null,
      showDownloadAtIndex: null,
      submissionStatus: null,
    };
  }

  updateSortFilter(filter, state, date, developer, statusOption) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
    }

    this.search.filtered = filter;
    this.search.date = date ? date.toISOString().substring(0, 10) : '';
    this.setState({ date });

    this.search.developer = developer ? developer.value : null;

    this.search.status = statusOption ? statusOption.value : null;
    this.setState({ submissionStatus: statusOption });

    this.props.listProjectInspection(
      this.search.pageSize,
      this.search.page,
      this.search.filtered,
      this.search.date,
      this.search.developer,
      this.search.status,
    );
  }

  renderDownloadItems() {
    const { attachments, isLoadingAttachments, t } = this.props;
    const { showDownloadAtIndex, target } = this.state;

    return (
      <Overlay
        show={showDownloadAtIndex !== null}
        target={target}
        placement="bottom"
        container={this}
        containerPadding={20}
      >
        <Popover id="popover-contained" title={t('attachments')} style={{ width: 300 }}>
          {isLoadingAttachments ?
            t('loading')
            :<ul>
              {attachments.map(({ id, name, attachment }) =>
                <li key={`att-${id}`}>
                  <a href={attachment} target="_blank">{name}</a>
                </li>
              )}
            </ul>
          }
        </Popover>
      </Overlay>
    );
  }

  renderSearchControls() {
    const { filtered, t } = this.props;
    const { date, focused, developer, submissionStatus } = this.state;
    const statusOptions = Object.values(Constants.PROJECT_SUBMISSION)
      .filter(status => status !== Constants.PROJECT_SUBMISSION.DRAFT)
      .map(status => ({ value: status, label: t(status) }));

    return (
      <div className="filter-box">
        <SearchBar
          onSearch={text => this.updateSortFilter(text, null, date, developer, submissionStatus)}
        />
        <div>
          <SingleDatePicker
            placeholder={t('submitted date')}
            date={date}
            onDateChange={date => this.updateSortFilter(filtered, null, date, developer, submissionStatus)}
            isOutsideRange={day => this.today <= day}
            focused={focused}
            onFocusChange={({ focused }) => this.setState({ focused })}
            showClearDate={true}
            id="project-submission-date-filter"
            small
          />
        </div>
        <PaginateSelect
          className="react-select-container right-margin"
          classNamePrefix="react-select"
          placeholder={t('sender')}
          isClearable={true}
          loadOptions={(value, page) => this.props.listDeveloper(page, value)}
          onChange={developer => this.updateSortFilter(filtered, null, date, developer, submissionStatus)}
          cacheOptions
          defaultoptions
        />
        <Select
          style={{ margin: '20px 10px 0 0' }}
          className="react-select-container right-margin"
          classNamePrefix="react-select"
          placeholder={t('status')}
          isClearable={true}
          options={statusOptions}
          value={submissionStatus}
          onChange={option => this.updateSortFilter(filtered, null, date, developer, option)}
        />
      </div>
    );
  }

  render() {
    const { filteredCount, isLoading, filtered, t } = this.props;
    const { date, developer, submissionStatus } = this.state;

    const breadcrumbItems = [
      { name: t('project'), path: `/project_inspection` },
    ];

    return (
      <Layout history={this.props.history} breadcrumbItems={breadcrumbItems}>
        <Card padding={false}>
          <Tabs
            id="project-inspection-tabs"
            onSelect={key => this.setState({ tabActiveKey: key })}
          >
            <Tab eventKey={1} title={t('project')}>
              {this.renderSearchControls()}
              <DataTable
                columns={this.columns}
                data={this.props.project_inspections}
                filteredCount={filteredCount}
                isLoading={isLoading}
                onActionCustom={({ original, index }) => {
                  const target = document.getElementsByClassName('fas fa-cloud-download-alt')[index];
                  const showDownloadAtIndex = this.state.showDownloadAtIndex !== index;
                  this.setState({
                    target,
                    showDownloadAtIndex: showDownloadAtIndex ? index : null,
                  });
                  if (showDownloadAtIndex) {
                    this.props.listAttachment(original.id);
                  }
                }}
                customActionIcon="fas fa-cloud-download-alt"
                shouldShowActionMenu={(actionName, { original }) => DataTable.ACTION_CUSTOM === actionName && original.has_attachments}
                onFetchData={state => this.updateSortFilter(filtered, state, date, developer, submissionStatus)}
              />
              {this.renderDownloadItems()}
            </Tab>
          </Tabs>
        </Card>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: state.projectInspection.isLoading,
  filteredCount: state.projectInspection.filteredCount,
  project_inspections: state.projectInspection.orderedIds.map(id => state.projectInspection.objects[id]),
  project_inspections_history: state.projectInspectionHistory.orderedIds.map(id => state.projectInspectionHistory.objects[id]),
  isLoadingAttachments: state.submissionAttachment.isLoading,
  attachments: state.submissionAttachment.orderedIds.map(id => state.submissionAttachment.objects[id]),
  errorMessage: state.projectInspection.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  listProjectInspection: (pageSize, page, filtered, date, developer, status) =>
    defaultRejectHandler(dispatch(listProjectInspection(pageSize, page, [{ id: 'id', desc: true }], filtered, date, developer, status))),
  listAttachment: submissionId => defaultRejectHandler(dispatch(listAttachment(submissionId))),
  listDeveloper: (page, filtered) => searchProfile(Constants.DATA_TABLE_PAGE_SIZE, page, null, filtered)
    .then(({ data }) => data.map(profile => ({ label: profile.username, value: profile.id } )))
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ProjectInspectionPage),
);



// WEBPACK FOOTER //
// ./src/pages/project_inspection/ProjectInspectionPage.js